import { Box } from "@material-ui/core"
import FilterPanel from "src/pages/FilterPanel"
import FreeTextSearchInput from "src/ui/FreeTextSearchInput"

import AddButton from "../helperComponents/AddButton"
import BreadcrumbsComponent from "./breadcrumbsComponent"

const FilterSection = ({
    type,
    path,
    dispatcher,
    setSearchText,
    setRecordToEdit,
    setCustomFilterQuery,
    isViewFilterPanel = true,
    isViewFilterWithSearch = true
}) => {
    return (
        <Box display={"flex"} flexDirection={"column"} justifyContent={"start"} alignItems={"start"} gap={"1rem"}>
            {/* Breadcrumbs & add button*/}
            <Box
                width="100%"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                flexWrap="wrap"
                sx={{
                    flexDirection: { xs: "column", sm: "row" },
                    gap: { xs: 2, sm: 0 },
                    alignItems: { xs: "flex-start", sm: "center" },
                }}
            >
                <BreadcrumbsComponent type={type} path={path} />
                <AddButton
                    type={type}
                    onClick={() => setRecordToEdit({})}
                    setCustomFilterQuery={setCustomFilterQuery}
                />
            </Box>

            {isViewFilterWithSearch &&
                <Box bgcolor={"white"} width={"100%"} display={"flex"} flexDirection={"column"} justifyContent={"start"} alignItems={"start"} gap={"1.5rem"} paddingX={"10px"} paddingY={"16px"} borderRadius={"8px"}>
                    {setCustomFilterQuery && isViewFilterPanel && (
                        <FilterPanel
                            dispatcher={dispatcher}
                            setCustomFilterQuery={setCustomFilterQuery}
                        />
                    )}
                    {/* Search input box */}
                    <FreeTextSearchInput onChange={setSearchText} />
                </Box>}

        </Box>
    )
}

export default FilterSection